import React from 'react';

import {
  BlinkingIndicatorBadge,
  BlinkingIndicatorContent,
} from '@/shared/components/ui/blinking-indicator/blinking-indicator.styled';
import { TBlinkingIndicatorProps } from '@/shared/components/ui/blinking-indicator/blinking-indicator.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

export const BlinkingIndicator: React.FC<TBlinkingIndicatorProps> = ({
  children,
  visible = false,
  color = 'warning',
  size = 10,
  top = -2,
  right = -1,
  blinkDuration = '1.2s',
  tooltip,
  tooltipProps,
}) => {
  if (!visible) {
    if (!children) {
      return null;
    }

    return <BlinkingIndicatorContent>{children}</BlinkingIndicatorContent>;
  }

  return (
    <Tooltip title={tooltip} {...tooltipProps}>
      <BlinkingIndicatorBadge
        color={color}
        variant="dot"
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        invisible={!visible}
        $size={size}
        $top={top}
        $right={right}
        $blinkDuration={blinkDuration}
      >
        <BlinkingIndicatorContent>{children}</BlinkingIndicatorContent>
      </BlinkingIndicatorBadge>
    </Tooltip>
  );
};
